import { Typography } from '@mui/material';
import React from 'react';
import { V } from '../../common/Layout';
import EllipsisText from '../../common/components/EllipsisText';
import TypePreview from '../TypePreview';
import { ReferenceField } from '../attributes';

type ReferenceFieldPreviewProps = {
    field: ReferenceField;
    onClick?: (field: ReferenceField) => void;
};

export default function ReferenceFieldPreview({ field, onClick }: ReferenceFieldPreviewProps) {
    return (
        <V onClick={onClick ? () => onClick(field) : undefined}>
            <TypePreview type={field.fieldType} />
            <EllipsisText text={field.label} sx={{ width: '140px' }} />
            <EllipsisText
                text={field.description}
                clampLines={2}
                sx={{ fontSize: 'smaller', color: 'text.disabled', width: '140px' }}
            />
            <Typography fontSize="smaller" color={'text.secondary'}>
                {field.entityToReference}
            </Typography>
        </V>
    );
}
